import PmoShell from "./PmoShell";
import RegistryPanel from "@/components/RegistryPanel";

export default function PmoRegistry() {
  return (
    <PmoShell
      supervisorOnly
      title="Resource Registry"
      subtitle="The organization-wide record of everyone you work with — contacts, roles, influence, reporting lines and measured delivery velocity."
      testid="pmo-registry-page"
    >
      <RegistryPanel />
    </PmoShell>
  );
}
